











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {AuditoriaTransfolha} from '@/model/resource/AuditoriaTransfolha'
import {AuditoriaTransfolhaCollection} from '@/model/collection/AuditoriaTransfolhaCollection'
import {ListAuditoriaTransfolhaSchema} from '@/schema/resource/AuditoriaTransfolha/ListAuditoriaTransfolhaSchema'
import {CsvAuditoriaTransfolhaSchema} from '@/schema/resource/AuditoriaTransfolha/CsvAuditoriaTransfolhaSchema'

@Component
export default class ListAuditoriaTransfolhaView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListAuditoriaTransfolhaSchema()
  collection = new AuditoriaTransfolhaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: AuditoriaTransfolha) {
    Helper.pushByName('editAuditoriaTransfolha')
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new AuditoriaTransfolhaCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvAuditoriaTransfolha()
    new CsvAuditoriaTransfolhaSchema().downloadCsv(csv.all())
  }
}
